import { FILE_TOO_LARGE } from '@/constant/uploadFile';
import { IResponseDetailMaterial } from '@/interfaces/doccen-lib/contentManagement.interface';
import { EUserSubscriptionStatus } from '@/interfaces/subscription.interface';
import { doceenLibMaterialAI } from 'apis/tms/library/material.api';
import { checkSubscriptionResource } from 'common/subscription/checkSubscriptionResource';
import { PATH_NAME } from 'configs/pathName';
import { useRouter } from 'next/router';
import { UseMutationResult, useMutation } from 'react-query';
import useGetLatestSubscription from '../subscription/useGetLatestSubscription';
import useToast from '../useToast';

const useAnalyzeDocumentToAI = (
  document: IResponseDetailMaterial | undefined,
  toggleModalUpgradePlan: () => void,
  toggleModalSubscriptionPackages: () => void
): UseMutationResult<{ conversationId: string }, any, void, unknown> => {
  const toast = useToast();
  const router = useRouter();

  const mutationReturn = useMutation({
    mutationFn: async () => doceenLibMaterialAI(document?.material.id || ''),
    onSuccess(data) {
      const url = `${PATH_NAME.AI}/${data.conversationId}`;
      router.push(url);
    },
    onError(err: any) {
      if (err.response.data.messages[0] === FILE_TOO_LARGE) {
        toggleModalUpgradePlan();
      } else {
        toast('Xảy ra lỗi ', 'error');
      }
    },
  });

  const { data: latestPlan } = useGetLatestSubscription({});

  return {
    ...mutationReturn,
    mutate: () => {
      if (
        !latestPlan?.subscription ||
        latestPlan.subscription.status !== EUserSubscriptionStatus.Active
      ) {
        toggleModalSubscriptionPackages();
        return;
      }

      if (
        document &&
        document?.material.metadata.pageCount >
          checkSubscriptionResource(latestPlan).document.maxPageCountForAI
      ) {
        toggleModalUpgradePlan();
        return;
      }
      mutationReturn.mutate();
    },
  };
};

export default useAnalyzeDocumentToAI;
